import cn from 'classnames';
import { useAppSelector, useTranslation } from 'client/hooks';
import { selectMuxDetailsMicWarn } from 'client/redux/mux-details/selectors';
import React from 'react';

import css from './MicWarning.module.scss';

interface Props {
  className?: string;
  size?: 'large' | 'default';
}

export const MicWarning: React.FC<Props> = (props) => {
  const { className = '', size = 'default' } = props;
  const { translate } = useTranslation('actionsPanel');
  const micWarning = useAppSelector(selectMuxDetailsMicWarn);

  if (!micWarning) return null;

  return (
    <div className={cn(css.micWarningWrapper, css[size], className)}>
      <div className={css.micWarningLabel}>!</div>
      <div className={css.warningInfo}>{translate('btns.micBlocked')}</div>
    </div>
  );
};
